import type { FaireProductEntity } from "../../entity_types/product";

export const p_dcmjf9n3jy: FaireProductEntity = {
  token: "p_dcmjf9n3jy",
  type: "product",
  name: "I Like Dogs More Than People Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/c1569be6bc3f8fb1b3530e8d28839de29f3fac8cc81c74ef6d8aa4be585e2a7a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f0b69280527449482bf2c03735c4b9080b41bb0f2a95bd4eeda59afc93598358.jpeg",
    "https://cdn.faire.com/fastly/6ff987e0b7113eaae643f9d6622fa218079b6513530194e793ee4e5d39874076.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/a9eabac6ca6b9dbc9a5f0ba473a3d5dbb9d1e88d99c3977909acdfa8abdbdf10.jpeg",
    "https://cdn.faire.com/fastly/f982c20fdf928518aee5d886b2dd582b049c40eb2150d64dbf9527e59bad22a7.jpeg",
    "https://cdn.faire.com/fastly/d007c9aba2fc0bb3afff28dada7cdb4321768175a34d1ac3b5a5397bb436a94c.jpeg",
    "https://cdn.faire.com/fastly/e66488821f95a1a3b79078778ce05f13bfa5dcfa67d3e5180472caa8769fa95c.jpeg",
    "https://cdn.faire.com/fastly/b5bb2d39ec4ea715cc6a333280c1ecd8f047d90d5d75a6a1ef9c4c37f7c17633.jpeg"
  ],
  priceDollars: 6.75,
  description: "Do you like long walks, couch cuddles, and peeing on hydrants? Then these socks are for you! Let the world see what we all know is 100% accurate: Dogs are more likable than people.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:52.743Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
